import { createContext } from 'react'

export const LayoutModeContext = createContext<
  ((mode: 'full' | 'auto') => void) | null
>(null)
